import { ExchangesMain } from '../../components/ExchangesMain';

export const ExchangesPage = () => {
   return (
      <>
         <ExchangesMain />
      </>
   );
};
